
export const ticketStatus = {
  NEW: "NEW",
  ISSUED: "ISSUED",
  PAID: "PAID",
  OVERDUE: "OVERDUE",
  STOPPED: "STOPPED",
  DOWNPAID: "DOWNPAID",
  CHECK: "CHECK",
  DONE: "DONE",
  PENDING: "PENDING",
  PENDING_ACTIVATION: "PENDING_ACTIVATION",
  GRACE: 'GRACE',
  WAIT: 'WAIT',
  PARKING_GRACE: 'PARKING_GRACE'
};

export const ticketUserStatus = {
  OPEN: "OPEN",
  PAID: "PAID",
  CANCELLED: "CANCELLED",
  CLOSED: "CLOSED",
  NONE: "NONE"
};

export const customerDocumentStatus = {
  CREATED: "CREATED",
  SENT: "SENT",
  DELIVERED: "DELIVERED",
  FAILED_DELIVERY: "FAILED_DELIVERY",
  CANCELLED: "CANCELLED",
  ERROR: "ERROR",
  DOWNLOADED: "DOWNLOADED",
  SUSPENDED: "SUSPENDED",
  DOWNLOAD_FAILED: "DOWNLOAD_FAILED",
  UNDELIVERABLE: "UNDELIVERABLE",
};

export const notificationType = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
};

export const parkingZoneOwnershipRequestStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  DENIED: "DENIED",
};

export const requestType = {
  TICKET_CANCELLATION_REQUEST: "TICKET_CANCELLATION_REQUEST",
  PARKING_ZONE_OWNERSHIP_REQUEST: "PARKING_ZONE_OWNERSHIP_REQUEST",
  DELETE_USER_REQUEST: "DELETE_USER_REQUEST",
  GAS_STATION_OWNERSHIP_REQUEST: "GAS_STATION_OWNERSHIP_REQUEST",
  TICKET_FEE_CANCELLATION_REQUEST: "TICKET_FEE_CANCELLATION_REQUEST",
  PZ_VALIDATION_REQUEST: "PZ_VALIDATION_REQUEST",
};

export const ticketLegalStatus = {
  NONE: "NONE",
  REMINDED: "REMINDED",
  SUED: "SUED",
  TERMINATED: "TERMINATED",
  INVOICE_SENT: "INVOICE_SENT",
  OPERATION_DOC_SENT: "OPERATION_DOC_SENT",
  TO_SUE: "TO_SUE",
  TO_BE_ENFORCED: "TO_BE_ENFORCED",
  PENALTY_FEE_DEMANDED: "PENALTY_FEE_DEMANDED",
  LAST_REMINDER: "LAST_REMINDER"
};

export const gasStationTicketCategory = {
  INTENT: "INTENT",
  PROMISSORY_NOTE: "PROMISSORY_NOTE",
  DEBT_NOTE: "DEBT_NOTE",
  PUMP_SWAPPED: "PUMP_SWAPPED",
  OTHER_REASON: "OTHER_REASON",
  INTENT_PARTIAL_PAYMENT_WITHOUT_FUEL_CASH: "INTENT_PARTIAL_PAYMENT_WITHOUT_FUEL_CASH",
  INTENT_PARTIAL_PAYMENT_WITHOUT_FUEL_CARD: "INTENT_PARTIAL_PAYMENT_WITHOUT_FUEL_CARD",
  INTENT_CARD_PAYMENT_INCOMPLETE: "INTENT_CARD_PAYMENT_INCOMPLETE",
};

export const ticketSeriesType = {
  PARKING_ZONE: "PARKING_ZONE",
  DRIVE_OFF: "DRIVE_OFF",
};

export const reportType = {
    VIOLATIONS: "VIOLATIONS",
    DRIVE_OFFS: "DRIVE_OFFS",
}

export const colors = {
  red: 'rgba(193, 18, 28, 1)',
  yellow: 'rgba(240, 202, 0, 1)',
  green: 'rgba(0, 132, 85, 1)',
  blue: 'rgba(0, 90, 140, 1)',
  gray: 'rgba(142, 146, 145, 1)',
};

export const supportedCountries = {
  "CH": { label: "Switzerland" },
  "DE": { label: "Germany" },
  "AT": { label: "Austria" },
  "ALL" : { label: "All" }
};
export const ALL_COUNTRY = "ALL";
export const ALLOWED_NEIGHBOURING_COUNTRIES: Record<
  string,
  { value: string; labelKey: string }[]
> = {
  CH: [
    { value: "CH", labelKey: "ModalEditTicket.CountryCodeOptions.CH" },
    { value: "A",  labelKey: "ModalEditTicket.CountryCodeOptions.A" },
    { value: "F",  labelKey: "ModalEditTicket.CountryCodeOptions.F" },
    { value: "D",  labelKey: "ModalEditTicket.CountryCodeOptions.D" },
    { value: "I",  labelKey: "ModalEditTicket.CountryCodeOptions.I" },
    { value: "FL", labelKey: "ModalEditTicket.CountryCodeOptions.FL" },
    { value: "other", labelKey: "ModalEditTicket.CountryCodeOptions.Other" }
  ],

  AT: [
    { value: "A",  labelKey: "ModalEditTicket.CountryCodeOptions.A" },
    { value: "CZ", labelKey: "ModalEditTicket.CountryCodeOptions.CZ" },
    { value: "D",  labelKey: "ModalEditTicket.CountryCodeOptions.D" },
    { value: "H",  labelKey: "ModalEditTicket.CountryCodeOptions.H" },
    { value: "I",  labelKey: "ModalEditTicket.CountryCodeOptions.I" },
    { value: "FL", labelKey: "ModalEditTicket.CountryCodeOptions.FL" },
    { value: "SK", labelKey: "ModalEditTicket.CountryCodeOptions.SK" },
    { value: "SLO", labelKey: "ModalEditTicket.CountryCodeOptions.SLO" },
    { value: "CH",  labelKey: "ModalEditTicket.CountryCodeOptions.CH" },
    { value: "other", labelKey: "ModalEditTicket.CountryCodeOptions.Other" }
  ],

  DE: [
    { value: "D",  labelKey: "ModalEditTicket.CountryCodeOptions.D" },
    { value: "A",  labelKey: "ModalEditTicket.CountryCodeOptions.A" },
    { value: "B",  labelKey: "ModalEditTicket.CountryCodeOptions.B" },
    { value: "CZ", labelKey: "ModalEditTicket.CountryCodeOptions.CZ" },
    { value: "DK", labelKey: "ModalEditTicket.CountryCodeOptions.DK" },
    { value: "F",  labelKey: "ModalEditTicket.CountryCodeOptions.F" },
    { value: "L",  labelKey: "ModalEditTicket.CountryCodeOptions.L" },
    { value: "NL", labelKey: "ModalEditTicket.CountryCodeOptions.NL" },
    { value: "PL", labelKey: "ModalEditTicket.CountryCodeOptions.PL" },
    { value: "CH", labelKey: "ModalEditTicket.CountryCodeOptions.CH" },
    { value: "other", labelKey: "ModalEditTicket.CountryCodeOptions.Other" }
  ]
};

export const getOptionsForZone = (zoneCountryCode?: string) => {
  if (!zoneCountryCode) return [];

  return ALLOWED_NEIGHBOURING_COUNTRIES[zoneCountryCode.toUpperCase()] ?? [];
};



export const vehicleTypeOptions = [
  { value: "Car", labelKey: "ModalEditTicket.VehicleTypeOptions.Car" },
  { value: "Truck", labelKey: "ModalEditTicket.VehicleTypeOptions.Truck" },
  { value: "Motorcycle", labelKey: "ModalEditTicket.VehicleTypeOptions.Motorcycle" },
  { value: "Other", labelKey: "ModalEditTicket.VehicleTypeOptions.Other" },
];

export const cancellationReasonsDriveOff = [
  { value: "CASHIERS_MISTAKE", label: "CASHIERS_MISTAKE"  },
  { value: "PAYMENT_TERMINAL_DEFECTIVE", label: "PAYMENT_TERMINAL_DEFECTIVE" },
  { value: "GOODWILL", label: "GOODWILL" },
  { value: "INPUT_ERROR", label: "INPUT_ERROR" },
  { value: "GOODWILL_BEPPO", label: "GOODWILL_BEPPO" },
  { value: "POOR_IMAGE_QUALITY", label: "POOR_IMAGE_QUALITY" },
  { value: "CUSTOMER_PAID_AT_GAS_STATION", label: "CUSTOMER_PAID_AT_GAS_STATION" }
];

export const cancellationReasonsParking = [
  { value: "PARKING_PERMISSION_GRANTED", label: "PARKING_PERMISSION_GRANTED"  },
  { value: "GOODWILL", label: "GOODWILL" },
  { value: "INPUT_ERROR", label: "INPUT_ERROR" },
  { value: "GOODWILL_BEPPO", label: "GOODWILL_BEPPO" },
  { value: "POOR_IMAGE_QUALITY", label: "POOR_IMAGE_QUALITY" },
];

export const parkingViolationTypes = [
    { value: "CH_ZPO", label: "CH_ZPO", price: 60, additionalCost: 10, reminderFee: 10, lastReminderFee: 10,
     paymentPeriod: "14", reminderPaymentPeriod: "7", lastReminderPaymentPeriod: "7" },
    { value: "CH_NON_ZPO", label: "CH_NON_ZPO", price: 60, additionalCost: 10, reminderFee: 10, lastReminderFee: 10,
     paymentPeriod: "14", reminderPaymentPeriod: "7", lastReminderPaymentPeriod: "7" },
    { value: "AT_ZPO", label: "AT_ZPO", price: 80, additionalCost: 15.10, reminderFee: 10, lastReminderFee: 10,
     paymentPeriod: "10", reminderPaymentPeriod: "5", lastReminderPaymentPeriod: "5" },
    { value: "DE_NON_ZPO", label: "DE_NON_ZPO" },
];

export const ticketSeriesTypes = [
    { value: "CH_PARKING", label: "Ticket.CH_PARKING" },
    { value: "CH_PARKING_VIOLATION_ZPO", label: "Ticket.CH_PARKING_VIOLATION_ZPO" },
    { value: "CH_PARKING_VIOLATION_NON_ZPO", label: "Ticket.CH_PARKING_VIOLATION_NON_ZPO" },
    { value: "CH_DRIVE_OFF", label: "Ticket.CH_DRIVE_OFF" },
    { value: "AT_PARKING_VIOLATION_ZPO", label: "Ticket.AT_PARKING_VIOLATION_ZPO" },
    { value: "AT_DRIVE_OFF", label: "Ticket.AT_DRIVE_OFF" },
    { value: "DE_PARKING_VIOLATION_NON_ZPO", label: "Ticket.DE_PARKING_VIOLATION_NON_ZPO" },
    { value: "DE_DRIVE_OFF", label: "Ticket.DE_DRIVE_OFF" },
];

export const closeReasons = [
  { value: "REPORTED_TO_POLICE", label: "REPORTED_TO_POLICE"  },
  { value: "INSUFFICIENT_EVIDENCE", label: "INSUFFICIENT_EVIDENCE" },
  { value: "NO_FOLLOW_UP", label: "NO_FOLLOW_UP" }
];

export const generalParkingRulesTypes = [
  { value: "CUSTOMERS_ONLY", label: "CUSTOMERS_ONLY"  },
  { value: "AUTHORIZATION_ONLY", label: "AUTHORIZATION_ONLY" },
];

export const vehiclesAuthorizationTypes     = [
  { value: "TIME_LIMITED_PARKING", label: "TIME_LIMITED_PARKING"  },
  { value: "QR_CODE", label: "QR_CODE" },
  { value: "WHITELIST", label: "WHITELIST" },
  { value: "PARKING_CARD", label: "PARKING_CARD" },
  { value: "PARKING_PAY_AND_SBB", label: "PARKING_PAY_AND_SBB" },
  { value: "CASH_ONLY", label: "CASH_ONLY" },
  { value: "OTHER", label: "OTHER" },                
];

export const handlingOppositionTypes     = [
  { value: "NO_REFER_BEPPO_DECIDES", label: "NO_REFER_BEPPO_DECIDES"  },
  { value: "REFER_NO_DECISION_BEPPO", label: "REFER_NO_DECISION_BEPPO" },
  { value: "NO_REFER_EXCEPT_SCENARIO", label: "NO_REFER_EXCEPT_SCENARIO" },
  { value: "NO_REFER_BEPPO_REFERS", label: "NO_REFER_BEPPO_REFERS" },  
];

export const paymentSolutionTypes     = [
  { value: "PARKING_PAY", label: "PARKING_PAY"  },
  { value: "SBB", label: "SBB" },
  { value: "PARKING_PAY_AND_SBB", label: "PARKING_PAY_AND_SBB" },
];
